import React from 'react';
import moment from "moment";
import Axios from "axios";
import 'moment/locale/fr'
import './addStyle.css';
import {useState, useEffect} from 'react';

function EditEvent() {

    const [dateSelected , setDateSelected] = useState("");
    const [eventsAtDate , setEventsAtDate] = useState([]);
    const [eventSelected , setEventSelected] = useState();
    const [eventToEdit , setEventToEdit] = useState();

    const [newTheme , setNewTheme] = useState("");
    const [newName , setNewName] = useState("");
    const [newHour , setNewHour] = useState("");
    const [newDay, setNewDay] = useState("");
    const [newDesc, setNewDesc] = useState("");
    const [newPlace, setNewPlace] = useState("");
    const [newAddr, setNewAddr] = useState("");
    const [newCons, setNewCons] = useState("");

    const [infoSent, setInfoSent] = useState("");






    useEffect(() => {

        if(eventSelected){
            setNewTheme(eventSelected.eventTheme);
            setNewName(eventSelected.eventName);
            setNewHour(eventSelected.eventHour);
            setNewDay(moment(eventSelected.eventDate, "DD/MM/YYYY").format("YYYY-MM-DD"));
            setNewDesc(eventSelected.eventDescr);
            setNewPlace(eventSelected.eventPlace);
            setNewAddr(eventSelected.eventAddr);
            setNewCons(eventSelected.eventCons);
        }
    
      }, [eventSelected]);



    const onChangeDate = (e) => {
        setDateSelected(moment(e.target.value, "YYYY-MM-DD").format("DD-MM-YYYY"));
    }

    const onSubmit = (e) => {
        e.preventDefault();

        setEventSelected("");

        if(dateSelected){
            Axios.get(`https://mlvoplanning.herokuapp.com/getbydate/${dateSelected}`).then((response) => {
                setEventsAtDate(response.data);
              })
        }
    }

    const onEdit = (ev) => {
        setEventSelected(ev);
        setEventToEdit(ev);
    }

    const changeTheme = (e) => {
        setNewTheme(e.target.value);
    }

    const changeName = (e) => {
        setNewName(e.target.value);
    }

    const changeHour = (e) => {
        setNewHour(e.target.value);
    }

    const changeDay = (e) => {
        setNewDay(e.target.value);
    }

    const changeDesc = (e) => {
        setNewDesc(e.target.value);
    }

    const changePlace = (e) => {
        setNewPlace(e.target.value);
    }

    const changeAddr = (e) => {
        setNewAddr(e.target.value);
    }

    const changeCons = (e) => {
        setNewCons(e.target.value);
    }



    const changeEv = (ev) => {

        ev.preventDefault();

        let nEvent = eventSelected;

        nEvent.eventTheme = newTheme;
        nEvent.eventName = newName;
        nEvent.eventHour = newHour;
        nEvent.eventDate = moment(newDay, "YYYY-MM-DD").format("DD/MM/YYYY");
        nEvent.eventDescr = newDesc;
        nEvent.eventPlace = newPlace;
        nEvent.eventAddr = newAddr;
        nEvent.eventCons = newCons;

        setEventSelected(nEvent);

        console.log(eventSelected);

        Axios.put
        (
            "https://mlvoplanning.herokuapp.com/update", 
            {
                id : eventSelected._id, 
                newEvent : eventSelected
            }
        )

        setInfoSent(`Evenement : ${nEvent.eventName} modifié avec succès.`);

    }


  return (

    <div>

        <form>
            <h2>MODIFIER EVENEMENT</h2>
            <label>Date de l'évènement : </label>
            <input
                type = "date"
                onChange={onChangeDate}
            />

            <div>
                <input
                    type = "submit"
                    value= "VALIDER"
                    className='sendBtn'
                    onClick={onSubmit}
                />
            </div>

            {eventsAtDate ? 

                <ul>
                    {
                    eventsAtDate.map((ev, k) => {
                        return(
                            <div>
                                <li key={k}> <img onClick={() => {onEdit(ev)}} src="https://upload.wikimedia.org/wikipedia/commons/6/64/Edit_icon_%28the_Noun_Project_30184%29.svg" style={{width : '15px' , height : '15px'}}/>[{ev.eventExt ? "EXT" : "INT"}] {ev.eventName} {ev.eventHour} {ev.eventPlace} ({ev.eventCons})</li>
                            </div>
                        );
                    })
                    }
                </ul>       
            :          
                "Pas d'évènements à cette date."   
            }
        </form>

        {eventSelected ? 

        <form style={{marginTop : "15px"}}>
            <div class="event-theme">
                <label>Thème : </label>
                <select name="eventExt" id="eventExt" value={newTheme} onChange={changeTheme}>
                    <option value="emploi">EMPLOI</option>
                    <option value="mobilite">MOBILITE</option>
                    <option value="logement">LOGEMENT</option>
                    <option value="infos">INFOS</option>
                    <option value="culture">CULTURE</option>
                    <option value="sante">SANTE</option>
                    <option value="sport">SPORT</option>
                    <option value="citoyennete">CITOYENNETE</option>
                    <option value="formation">FORMATION</option>
                </select>
            </div>
            <div>
                <label>Nom de l'évènement : </label>
                <input
                    type="text"
                    value={newName}
                    onChange= {changeName}
                />
            </div>

            <div class="event-date">
                <label>Date : </label>
                <input 
                        type="date" 
                        id="start" 
                        name="eventDate"
                        onChange={changeDay}
                />
            </div>

            <div>
                <label>Heure : </label>
                <input
                    type="text"
                    value={newHour}
                    onChange= {changeHour}
                />
            </div>

            <div class="event-descr">
                <label>Description : </label>
                <input 
                        type="text" 
                        value={newDesc}
                        onChange={changeDesc}
                />
            </div>

            <div class="event-addr">
                <label>Adresse : </label>
                <input 
                        type="text" 
                        value={newAddr}
                        onChange={changeAddr}
                />
            </div>

            <div class="event-place">
                <label>Lieu(*) : </label>
                <input 
                        type="text" 
                        value={newPlace}
                        onChange={changePlace}
                        required
                />
            </div>

            <div class="event-addr">
                <label>Conseiller(s)(*) : </label>
                <input 
                        type="text" 
                        value={newCons}
                        onChange={changeCons}
                        required
                />
            </div>

            <div>
                <input
                    type = "submit"
                    value= "VALIDER"
                    className='sendBtn'
                    onClick={changeEv}
                />
                <p>{infoSent}</p>
            </div>

        </form>
            :
        ""
        }
      
    </div>
  );
}

export default EditEvent;
